<template>
  <div id="app">
    <v-app-bar 
      color="#00796bd1"
      fixed 
      app
      dark
    >
      <v-app-bar-nav-icon to="/">
        <v-icon>mdi-home</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>
        <span class="text-uppercase">{{ system ? system.ten : config.sysTitle }} {{ config.provinceName }}</span>
      </v-toolbar-title>
      <v-spacer/>
      <router-link to="/">
        <v-img
          alt="Agri portal Logo"
          class="shrink mr-5"
          contain
          src="@/assets/logo.png"
          transition="scale-transition"
          :width="40"
        />
      </router-link>
      <router-link to="/">
        <v-img
          alt="Agri portal Logo"
          class="shrink mr-5"
          contain
          src="@/assets/logo-VNPT.png"
          transition="scale-transition"
          :width="30"
        />
      </router-link>
    </v-app-bar>
    <v-app>
      <v-main style="padding: 64px 0px 0;">
          <v-container fluid fill-height>
            <v-row align="center" justify="center">
              <v-col>
                <router-view/>
              </v-col>
            </v-row>
            <v-row v-if="otherProjects.length">
              <v-col cols="12">
                <v-slide-group multiple show-arrows="always">
                  <v-row justify="center" align="center" class="my-1">
                    <v-slide-item 
                      v-for="(orp, index) in otherProjects" 
                      :key="index" 
                      v-slot="{ active, toggle }"
                    >
                      <v-chip
                        pill
                        class="ma-5 pa-8"
                        @click="toOtherProject(orp.link)"
                      >
                        <v-avatar left>
                          <v-img :src="`${apiBaseUrl}/uploads/${orp.logo}`"/>
                        </v-avatar>
                        {{ orp.name }}
                      </v-chip>
                    </v-slide-item>
                  </v-row>
                </v-slide-group>
              </v-col>
            </v-row>
            <v-row v-else justify="center" class="mt-1 order-projects">
              <v-col md="auto" v-for="(orpLoading, index) in 3"
                :key="`orpLoading${index}`"
              >
                <v-skeleton-loader
                  class="mx-auto"
                  width="180"
                  height="90"
                  type="list-item-two-line"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-footer  
                  inset
                  style="background: transparent;"
                >
                  <v-container 
                    fluid
                    class="pb-0"
                  >
                    <v-row 
                      align="center" 
                      no-gutters
                      class="mt-5"
                    >
                      <v-col 
                        cols="12"
                        class="mx-auto text-center"
                      >
                        <p class="text-caption text-uppercase">
                          {{ system ? system.ten : config.sysTitle }} {{ config.provinceName }} © {{ (new Date()).getFullYear() }} 
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-footer>
              </v-col>
            </v-row>
          </v-container>
      </v-main>
    </v-app>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: "auth",
    data: () => ({
      otherProjects: []
    }),
    computed: {
      ...mapState([
        'system',
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted () {
      this.initialize()
      this.getSystem()
    },
    methods: {
      ...mapActions([
        'getSystem'
      ]),
      initialize () {
        axios.get("api/v1/public/web-links")
          .then(response => {
            this.otherProjects = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      backToHome(){
        this.$router.push({ name: 'Home' }) 
      },
      toOtherProject(link){
        window.open(
          link,
          '_blank'
        );
      }
    }
  };
</script>
<style>
  html{
    overflow-y: auto !important;
  }
</style>
<style scoped>
  .auth-title{
    font-weight: 500;
  }
  .v-application:before{
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    background-image: url('~@/assets/auth-bg-3.jpg') !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: bottom;
    opacity: 0.2 !important;
  }
  .v-slide-group__content {
    justify-content: center !important;
  }
</style>